import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
} from 'react-admin';


import {
  isRequired,
  isPostiveDecimal,
} from '../../validators';


export default props => (
  <Create
    {...props}
    title="Create Private Quote"
  >
    <SimpleForm>
      <TextInput source="ticker" label="Ticker Symbol" validate={isRequired} />
      <TextInput source="name" validate={isRequired} />
      <NumberInput source="purchasePrice" validate={isPostiveDecimal} />
      <NumberInput source="currentPrice" validate={isPostiveDecimal} />
    </SimpleForm>
  </Create>
);




// WEBPACK FOOTER //
// ./src/components/PrivateQuote/Create.js